import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable()
export class IBANService {
    constructor(private httpClient: HttpClient) {
    }

    getFreeIBANs(): Observable<any> {
        return this.httpClient.get('/api/backoffice/ibans/free')
            .map((ibanSuggested: { 'iban': string }) => ibanSuggested.iban);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/iban.service.ts